/** Recursively evaluate an ExprNode given variable bindings. */
export function evaluateExprNode(node, vars) {
    if (typeof node === 'number')
        return node;
    if (typeof node === 'string') {
        const varName = node.slice(1); // strip leading '$'
        if (!(varName in vars)) {
            throw new Error(`Unknown variable: ${node}`);
        }
        return vars[varName];
    }
    const left = evaluateExprNode(node.args[0], vars);
    const right = evaluateExprNode(node.args[1], vars);
    switch (node.op) {
        case '+':
            return left + right;
        case '-':
            return left - right;
        case '*':
            return left * right;
        case '/':
            if (right === 0)
                throw new Error('Division by zero');
            return left / right;
        case 'pow':
            return Math.pow(left, right);
        case 'min':
            return Math.min(left, right);
        case 'max':
            return Math.max(left, right);
        default:
            throw new Error(`Unknown op: ${node.op}`);
    }
}
